import {Stack, Typography, styled, css, alpha} from '@mui/material';
import {Loading} from 'presentation/components/Loading/Loading';
import {ContainerProps} from './types';

const Container = styled(Stack)<ContainerProps>`
	padding: 16px;
	width: 100%;
	cursor: grab;
	background-color: ${({theme, $isOnDrop, $isUploading}) =>
		$isOnDrop || $isUploading
			? theme.colors.light.primary['08Percent']
			: theme.palette.common.white};
	border-radius: 4px;
	border: 1px dashed
		${({theme, $isOnDrop, $isUploading}) =>
			$isOnDrop || $isUploading
				? theme.palette.primary.light
				: theme.colors.light.other.border};

	${({theme, $isError}) =>
		$isError &&
		css`
			border: 1px solid ${theme.colors.light.error.main};
			background-color: ${alpha(
				theme.palette.error.shades['4p'] ?? theme.palette.error.main,
				0.04,
			)};
		`}
`;

const Label = styled(Typography)`
	width: fit-content;
	margin: 0 auto;
	text-align: center;
	color: ${({theme}) => theme.colors.light.primary.main};
	border-bottom: 1px solid ${({theme}) => theme.colors.light.primary.main};
	cursor: pointer;
`;

const FileInput = styled('input')`
	width: 0.1px;
	height: 0.1px;
	opacity: 0;
	overflow: hidden;
	z-index: -1;
`;

const StyledLoading = styled(Loading)`
	background-color: ${({theme}) => alpha(theme.palette.primary.main, 0.12)};
	border-radius: 50%;
	padding: 8px;
	gap: 8px;
`;

export {Container, Label, FileInput, StyledLoading};
